/**
 * REST API contract constants. Keep paths and method names in sync with `docs/API.md`.
 */
export const API_VERSION = "v1";
// Prefix the reverse proxy strips before forwarding to ApiRoutes' real paths.
export const PUBLIC_API_PREFIX = "/api";
export const ApiRoutes = {
    health: `/${API_VERSION}/health`,
    authGoogleStart: `/${API_VERSION}/auth/google/start`,
    authGoogleCallback: `/${API_VERSION}/auth/google/callback`,
    authMe: `/${API_VERSION}/auth/me`,
    authLogout: `/${API_VERSION}/auth/logout`,
    apiTokens: `/${API_VERSION}/api-tokens`,
    vocab: `/${API_VERSION}/vocab`,
    vocabGenerate: `/${API_VERSION}/vocab/generate`,
    vocabAudio: `/${API_VERSION}/vocab/audio`,
    syncTargets: `/${API_VERSION}/sync-targets`,
    integrationsHealth: `/${API_VERSION}/integrations/health`,
    stats: `/${API_VERSION}/stats`,
    flashcardsDue: `/${API_VERSION}/flashcards/due`,
    settings: `/${API_VERSION}/settings`,
    practiceReading: `/${API_VERSION}/practice/reading`,
    practiceWritingPrompt: `/${API_VERSION}/practice/writing/prompt`,
    practiceWritingFeedback: `/${API_VERSION}/practice/writing/feedback`,
    statsDashboard: `/${API_VERSION}/stats/dashboard`,
};
export const SyncTargetKindLabels = {
    obsidian: "Obsidian note",
};
export const FlashcardKindLabels = {
    meaning_recall: "Meaning Recall",
    word_recall: "Word Recall",
    active_recall: "Active Recall",
    speaking_context: "Speaking Context",
    chunk_production: "Chunk Production",
};
//# sourceMappingURL=api.js.map